export class BookingData {
    availableSlots = [];
    bookedSlots = [];
    venueName: String;
}